import { SerializeMap } from "lib/serializerUtils";

export const paymentPreferencesSerializeMap: SerializeMap<PaymentPreference> = {
  saleType: "sale_type",
  id: "id",
  bankingDetailId: "banking_detail_id",
  speciesId: "species_id",
  saleSubTypeId: "sale_sub_type_id",
  businessIds: "business_ids",
};
